module.exports = __webpack_public_path__ + "static/media/badge_ENG_Google.722835c4.png";